import module from 'guest/module.js'

const schema = {}

class GuestIdiomaService {
  constructor ($http) {
    this.$http = $http
  }

  post (data) {
    return this.$http.post('/user/language', data, {
      schema,
    })
  }
}

module.service('GuestIdioma', GuestIdiomaService)



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Idioma.js